import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import api from "api/axios";

function ReinitialiserMotDePasse() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [motDePasse, setMotDePasse] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setError("");
    if (motDePasse.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    if (motDePasse !== confirmation) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/reinitialiser-mot-de-passe", {
        token,
        nouveau_mot_de_passe: motDePasse,
      });
      setSuccess(true);
      setTimeout(() => navigate("/authentication/sign-in"), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Erreur serveur.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MDBox
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: "#f0f2f5" }}
    >
      <Card sx={{ width: 400, p: 3 }}>
        <MDBox textAlign="center" mb={3}>
          <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#1976d2" }}>
            Gestion SI
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Réinitialisation du mot de passe
          </MDTypography>
        </MDBox>

        {success ? (
          <MDBox textAlign="center" py={3}>
            <MDTypography variant="h6" sx={{ color: "#43a047" }}>
              Mot de passe réinitialisé !
            </MDTypography>
            <MDTypography variant="body2" color="text" mt={1}>
              Vous allez être redirigé vers la page de connexion...
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox display="flex" flexDirection="column" gap={2}>
            <MDTypography variant="body2" color="text">
              Choisissez votre nouveau mot de passe.
            </MDTypography>
            <TextField
              label="Nouveau mot de passe"
              type="password"
              fullWidth
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
            />
            <TextField
              label="Confirmer le mot de passe"
              type="password"
              fullWidth
              value={confirmation}
              onChange={(e) => setConfirmation(e.target.value)}
            />

            {error && (
              <MDTypography variant="caption" color="error">{error}</MDTypography>
            )}

            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? "Enregistrement..." : "Réinitialiser mon mot de passe"}
            </MDButton>
          </MDBox>
        )}
      </Card>
    </MDBox>
  );
}

export default ReinitialiserMotDePasse;
